<template>
  <div class="points-box">
    <div class="points-content">
      <div class="illustration">
        <!-- Einfaches Smartphone mit QR-Code Platzhalter -->
        <div class="phone">
          <div class="screen">
            <div class="qr-code">QR</div>
          </div>
        </div>
      </div>
      <div class="text">
        <h2>Punkte sammeln!</h2>
        <p>Scanne den QR-Code mit deinem Smartphone und sammle exklusive Punkte.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PunkteSammelBox'
}
</script>

<style scoped>
.points-box {
  width: 280px;
  background-color: #fb5d00;
  border: 2px solid black;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
}
.points-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.illustration .phone {
  width: 80px;
  height: 140px;
  background-color: #fff;
  border-radius: 16px;
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}
.illustration .screen {
  width: 70px;
  height: 120px;
  background-color: #f0f0f0;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.illustration .qr-code {
  width: 50px;
  height: 50px;
  background-color: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  border-radius: 4px;
}
.text h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.text p {
  margin: 0;
  font-size: 14px;
  color: #333;
}
</style>
